export const flattenResponse = (res: { type: string; body: any }) => {
  const { type, body } = res;
  return { type, ...body };
};
